/* eslint-disable react-hooks/exhaustive-deps */
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSelector } from "src/stateManagement/redux";
import { HistoricalActivitiesDetails } from "./components/HistoricalActivitiesDetails";
import './historyDetail.scss'

export const HistoricalActividades = () => {
    const { fieldActivities } = useSelector((state) => state.location);
    const [data, setData] = useState([]);
    const [activityType, setActivityType] = useState("");
    const [showDetails, setShowDetails] = useState(false);

    const [dataForTable, setDataForTable] = useState<any[]>([])

    useEffect(() => {
        console.log({ fieldActivities })
        const dataForTable = fieldActivities.map((activity: any) => {

            const valTest = activity?.variables?.find((variable: any) => variable.id === "8a8c2c05-d3b1-410c-bb3e-a8fd717f0e86");
            const pressureText = activity?.variables?.find((variable: any) => variable.id === "e377cb89-3cf0-422f-a05b-a17f73187544");


            return {
                ...activity,
                presureTestExecuted: pressureText ? pressureText.value === 'true' : false,
                valveTestExecuted: valTest ? valTest.value === 'true' : false,
            }
        })

        setDataForTable(dataForTable);
    }, [fieldActivities])


    const handleShowDetails = (data: any, type: any) => {
        setData(data);
        setActivityType(type);
        setShowDetails(true);
    };

    const columns: GridColDef[] = [
        { field: "executedDate", headerName: "Fecha", flex: 0.4 },
        { field: "executedBy", headerName: "Responsable", flex: 0.4 },
        { field: "typeOfActivity", headerName: "Tipo de Actividad", flex: 0.5 },
        { field: "comments", headerName: "Comentario", flex: 1 },
        { field: "presureTestExecuted", headerName: "PP", flex: 0.1, type: 'boolean' },
        { field: "valveTestExecuted", headerName: "PV", flex: 0.1, type: 'boolean' },
        {
            field: "actions",
            headerName: "",
            flex: 0,
            renderCell: (params) => {
                return (
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() =>
                            handleShowDetails(
                                params.row.variables,
                                params.row.typeOfActivity
                            )
                        }
                    >
                        Detalles
                    </Button>
                );
            },
        }
    ];

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <Grid container spacing={0}>
            <Grid size={12}>
                {showDetails ? (
                    <HistoricalActivitiesDetails
                        setShowDetails={setShowDetails}
                        details={data}
                        activityType={activityType}
                    />
                ) : (
                    <Grid className="table">
                        <DataGrid
                            rows={dataForTable}
                            columns={columns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[10, 20, 50, 100]}
                            checkboxSelection={false}
                            sx={{
                                border: 0,
                                "& .MuiDataGrid-row:hover": {
                                    cursor: "pointer",
                                    backgroundColor: "#f5f5f5",
                                },
                                "& .MuiDataGrid-columnHeader": {
                                    backgroundColor: "#316EBC",
                                    color: "#fff",
                                    fontWeight: "bold",
                                },
                            }}
                            getRowId={(row) => row.fieldActivityId}
                        />
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};
